export default __webpack_public_path__ + "static/icon-2-3-99b2bdeb474772e1b5744785ac9e1bed.png";